import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from "../utils/util"
import { USER_ROLE } from "../constants/index"
import {
  MypageService, TalentViewService
} from "../api/services.gen";
import {
  MypageUpdateCreateData, MypageChangePasswordCreateData,
  MypageChangeBasicInfoUpdateData, MypageCareerInfoUpdateData,
  MypageBookmarkedListRetrieveData, MypageBookmarkedListMobileRetrieveData,
  TalentViewBookmarkStatusUpdateData, MypageUpdateFullInformationUpdateData,
  MypageUploadFileCreateData, MypageUploadFileUpdateData, MypageUploadFileDestroyData
} from "../api/types.gen";
import i18n from 'i18next';
import { resetAppState } from "../store/common";

interface TalentDetail {
  success: any;
  readonly id: number;
  avatar?: string | null;
  first_name: string;
  last_name: string;
  address?: string | null;
  change_job?: string | null;
  work_parttime?: string | null;
  expected_condition?: string | null;
  actionStatus: string;
  isReloadPage: boolean;
};

const initialState = {
  actionStatus: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  talent: {'change_job_status': { "id": null, "name": "ー" }, 'work_parttime_status': { "id": null, "name": "ー" }},
  isReloadStaff: false,
  success: false,
  loading: false,
  talentInfo: undefined as undefined | TalentDetail,
  isLoading: false,
  error: "",
  errors: {},
  talentDetail: null,
  listStatus: null,
  genderList: null,
  companyInformation: null,
  message: "",
  actionName: "",
  isSuccess: false,
  isOpenRegisterPanel: false,
  isEditing: false,
  changeJobStatusValue: "",
  workPartTimeStatus: "",
  actionStatusJob: "idle",
  gender: "",
  editingPassword: undefined,
  isChangePwCompleted: false,
  redirection: "",
  careerData: null,
  successImage: false,
  successCareer: false,
  changeJobOptions: [{ "id": null, "name": "ー" }],
  genderOptions: [{ "id": null, "name": "ー" }],
  professionOptions: [{ "id": null, "name": "ー" }],  // 職種
  industryOptions: [{ "id": null, "name": "ー" }],
  cityOptions: [{ "id": null, "name": "ー" }],
  residenceOptions: [{ "id": null, "name": "ー" }],
  workingStyleOptions: [{ "id": null, "name": "ー" }],
  bookmarkedItems: [],
  countItems: 0,
  currentPage: 1,
  pageSize: 6,
  bookmarkedItemsMobile: [],
  currentPageLoading: 1,
  pageSizeLoading: 6,
  totalResultsMobile: 0,
  hasMore: true,
  activeTab: "profile",
  isReloadBookmarkList: false,
  changeEmailStatus: { result: true, message: "" },
  initialData: {
    yearOfBirth: { id: new Date().getFullYear(), name: `${new Date().getFullYear()}`, icon: null },
    monthOfBirth: { id: new Date().getMonth() + 1, name: `${new Date().getMonth() + 1}`, icon: null },
    dateOfBirth: { id: new Date().getDate(), name: `${new Date().getDate()}`, icon: null },
    gender: { id: null, name: '', icon: null },
    startDate: '',
    endDate: '',
    first_name: '',
    last_name: '',
    first_name_kana: '',
    last_name_kana: '',
    email: '',
    city: '',
    do_want_news_email: true,
    do_want_scout_email: true,
    profession_1: null,
    profession_2: null,
    profession_3: null,
    preferred_city_1: null,
    preferred_city_2: null,
    preferred_city_3: null,
    working_style_1: null,
    working_style_2: null,
    working_style_3: null,
    industry_1: null,
    industry_2: null,
    industry_3: null,
    join_company_year: null,
    join_company_month: null,
    leave_company_year: null,
    leave_company_month: null,
    CV: null,
    RESUME: null,
    OTHER: null
  },
  initialBasicData: {
    yearOfBirth: { id: new Date().getFullYear(), name: `${new Date().getFullYear()}`, icon: null },
    monthOfBirth: { id: new Date().getMonth() + 1, name: `${new Date().getMonth() + 1}`, icon: null },
    dateOfBirth: { id: new Date().getDate(), name: `${new Date().getDate()}`, icon: null },
    gender: { id: null, name: '', icon: null }, startDate: '', endDate: '', last_name: '',
    first_name: '', email: '', last_name_kana: '', first_name_kana: '', city: '',
    join_company_year: null, join_company_month: null, leave_company_year: null, leave_company_month: null,
    leave_company_day: null
  },
  isReloadPage: false,
}

export const getTalentDetail = createAsyncThunk(
  'getTalentDetail',
  async (_, thunkAPI: any) => {
    try {
      const res = await MypageService.mypageRetrieve();
      if (res) { return res; }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  }
);

export const updateFullInformation = createAsyncThunk(
  "updateFullInformation",
  async (data: MypageUpdateFullInformationUpdateData, thunkAPI: any, requestData: any) => {
    try {
      const res = await MypageService.mypageUpdateFullInformationUpdate(data);
      if (res) {
        return res;
      }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_INTERNAL_SERVER_ERROR'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

export const mypageUploadFilePost = createAsyncThunk(
  "mypageUploadFilePost",
  async (data: MypageUploadFileCreateData, thunkAPI: any, requestData: any) => {
    try {
      const res = await MypageService.mypageUploadFileCreate(data);
      if (res) {
        return res;
      }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_INTERNAL_SERVER_ERROR'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

export const mypageUploadFileTempPost = createAsyncThunk(
  "mypageUploadFileTempPost",
  async (data: MypageUploadFileCreateData, thunkAPI: any, requestData: any) => {
    try {
      const res = await MypageService.mypageUploadFileCreate(data);
      if (res) {
        return res;
      }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_INTERNAL_SERVER_ERROR'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

export const mypageUploadFilePut = createAsyncThunk(
  "mypageUploadFilePut",
  async (data: MypageUploadFileUpdateData, thunkAPI: any, requestData: any) => {
    try {
      const res = await MypageService.mypageUploadFileUpdate(data);
      if (res) {
        return res;
      }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_INTERNAL_SERVER_ERROR'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

export const mypageUploadFileDelete = createAsyncThunk(
  "mypageUploadFileDelete",
  async (data: MypageUploadFileDestroyData, thunkAPI: any, requestData: any) => {
    try {
      const res = await MypageService.mypageUploadFileDestroy(data);
      if (res) {
        return res;
      }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_INTERNAL_SERVER_ERROR'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

// Create status for change job from talent
export const createStatus = createAsyncThunk(
  "createStatus",
  async (data: MypageUpdateCreateData, thunkAPI: any) => {
    try {
      const res = await MypageService.mypageUpdateCreate(data);
      if (res) {
        return res;
      }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_INTERNAL_SERVER_ERROR'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

//change Password
export const setChangePassword = createAsyncThunk(
  "setChangePassword",
  async (data:MypageChangePasswordCreateData, thunkAPI: any) => {
    try {
      const res = await MypageService.mypageChangePasswordCreate(data);
      if (res) {
        return res;
      }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_INTERNAL_SERVER_ERROR'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

//update basic information
export const updateBasicInformation = createAsyncThunk(
  "updateBasicInformation",
  async (data:MypageChangeBasicInfoUpdateData, thunkAPI: any) => {
    try {
      thunkAPI.dispatch(mypageActions.setIsLoading(true))
      thunkAPI.dispatch(mypageActions.setActionStatus('updateChange'))
      const res: any = await MypageService.mypageChangeBasicInfoUpdate(data);
      thunkAPI.dispatch(mypageActions.setIsLoading(false));
      if (res) {
        return res;
      }
      return thunkAPI.dispatch(mypageActions.setError(res.message))
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

// GeT status for change job from talent
export const getCareerInformation = createAsyncThunk(
  "getCareerInformation",
  async (_, thunkAPI: any) => {
    try {
      const res = await MypageService.mypageCareerInfoList();
      if (res) {
        return res;
      }
      return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_INTERNAL_SERVER_ERROR'));
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

// Update career information for talent
export const updateCareerInformation = createAsyncThunk(
  "updateCareerInformation",
  async (data:MypageCareerInfoUpdateData, thunkAPI: any) => {
    try {
      thunkAPI.dispatch(mypageActions.setIsLoading(true))
      const res: any = await MypageService.mypageCareerInfoUpdate(data);
      if (res) {
        return res;
      }
      return thunkAPI.dispatch(mypageActions.setError(res.message))
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

export const getBookmarkedList = createAsyncThunk(
  "getBookmarkedList",
  async (data: MypageBookmarkedListRetrieveData, thunkAPI: any) => {
    try {
      const res: any = await MypageService.mypageBookmarkedListRetrieve(data);
      if (res.results.success) {
        return res;
      }
      return thunkAPI.dispatch(mypageActions.setError(res.message))
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

export const getBookmarkedListMobile = createAsyncThunk(
  "getBookmarkedListMobile",
  async (data: MypageBookmarkedListMobileRetrieveData, thunkAPI: any) => {
    try {
      const res: any = await MypageService.mypageBookmarkedListMobileRetrieve(data);
      if (res.results.success) {
        return res;
      }
      return thunkAPI.dispatch(mypageActions.setError(res.message))
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

export const setItemBookmark = createAsyncThunk(
  "setItemBookmark",
  async (data: TalentViewBookmarkStatusUpdateData, thunkAPI: any) => {
    try {
      const res: any = await TalentViewService.talentViewBookmarkStatusUpdate(data);
      if (res.success) {
        return res;
      } else {
        return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
    }
  },
);

const handleGetBookmarkedListMobileFulfilled = (state: any, action: any) => {
  if(state.currentPageLoading == 1) state.bookmarkedItemsMobile = [];

  let countPageLoading = 0;
  state.totalResultsMobile = action.payload.count;
  if(state.totalResultsMobile == 0) {
    state.currentPageLoading = 1;
    state.bookmarkedItemsMobile = [];
  } 
  else {
    const newItems = action.payload.results.data;
    const merged = [...state.bookmarkedItemsMobile, ...newItems];
    const uniqueMap = new Map();
    merged.forEach(item => {
      const key = `${item.id}_${item.item_type}`;
      uniqueMap.set(key, item);
    });
    state.bookmarkedItemsMobile = Array.from(uniqueMap.values());           
    countPageLoading = Math.ceil(state.totalResultsMobile / state.pageSizeLoading);
  }
  
  if(state.currentPageLoading >= countPageLoading) state.hasMore = false;
  else state.hasMore = true;
}

const updateItemsById = (list, updatedItem) =>
  list.reduce((result, item) => {
    const isTargetItem =
      item.id === updatedItem.id && item.item_type === updatedItem.item_type;

    if (isTargetItem) {
      if (updatedItem.is_bookmarked === false) {
        return result;
      }
      return [...result, updatedItem];
    }

    return [...result, item];
  }, []);


const mypageSlice = createSlice({
  name: 'talentMypage',
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setTalentInfo: (state, action) => {
      state.talentInfo = action.payload
    },
    setActionName: (state, action) => {
      state.actionName = action.payload;
    },
    setActionStatus: (state, action) => {
      state.actionStatus = action.payload;
    },
    setEditingPassword: (state, action) => {
      state.editingPassword = action.payload
    },
    setInitState: (state) => {
      return initialState
    },
    setIsChangePwCompleted: (state, action) => {
      state.isChangePwCompleted = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setErrors: (state, action) => {
      state.errors = action.payload
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setCurrentPageLoading: (state, action) => {
      state.currentPageLoading = action.payload;
    },
    setHasMore: (state, action) => {
      state.hasMore = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setChangeEmailStatus: (state, action) => {
      state.changeEmailStatus = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // reset state
      .addCase(resetAppState, () => initialState)

      .addCase(getTalentDetail.pending, (state) => {
        state.actionStatus = 'loading';
      })
      .addCase(getTalentDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.actionStatus = 'fulfilled';
        state.success = action.payload.success;
        state.actionName = "getTalentDetail";
        state.talent = action.payload.data?.talent;
        state.changeJobOptions = action.payload.data?.options?.change_job_options;
        state.genderOptions = action.payload.data?.options?.gender_options;
        state.professionOptions = action.payload.data?.options?.profession_options;
        state.industryOptions = action.payload.data?.options?.industry_options;
        state.cityOptions = action.payload.data?.options?.city_options;
        state.residenceOptions = action.payload.data?.options?.residence_options;
        state.workingStyleOptions = action.payload.data?.options?.working_style_options;
      })
      .addCase(getTalentDetail.rejected, (state, action) => {
        state.actionStatus = 'failed';
        state.isLoading = false;
      })

      // updateFullInformation
      .addCase(updateFullInformation.pending, (state, action) => {
        state.loading = true;
        state.error = "null";
        state.actionStatus = "pending";
      })
      .addCase(updateFullInformation.fulfilled, (state, action) => {
        state.success = action.payload.success;
        state.loading = false;
        state.isLoading = false;
        state.message = action.payload.message;
        state.actionStatus = "fulfilled";
        state.actionName = "updateFullInformation";
        state.isReloadPage = !state.isReloadPage;
      })
      .addCase(updateFullInformation.rejected, (state, action) => {
        state.loading = false;
        state.isLoading = false;
        state.errors = action.payload || {};
        state.actionStatus = "rejected";
      })

      // Update createStatus
      .addCase(createStatus.pending, (state) => {
        state.loading = true;
        state.error = "null";
        state.actionStatus = "pending";
      })
      .addCase(createStatus.fulfilled, (state, action) => {
        state.success = action.payload.success;
        state.loading = false;
        state.isLoading = false;
        state.message = action.payload.message;
        state.actionStatus = "fulfilled";
        state.actionName = "updateChangeJobStatus";
        state.isReloadPage = !state.isReloadPage;
      })
      .addCase(createStatus.rejected, (state, action) => {
        state.loading = false;
        state.isLoading = false;
        state.errors = action.payload || {};
        state.actionStatus = "rejected";
      })
      // File uploading post
      .addCase(mypageUploadFilePost.pending, (state) => {
        state.loading = true;
        state.error = "null";
        state.actionStatus = "pending";
      })
      .addCase(mypageUploadFilePost.fulfilled, (state, action) => {
        state.success = action.payload.success;
        state.loading = false;
        state.isLoading = false;
        state.message = action.payload.message;
        state.actionStatus = "fulfilled";
        state.actionName = "fileUploadPosting";
        state.isReloadPage = !state.isReloadPage;
      })
      .addCase(mypageUploadFilePost.rejected, (state, action) => {
        state.loading = false;
        state.isLoading = false;
        state.errors = action.payload || {};
        state.actionStatus = "rejected";
      })
      // File uploading post with update
      .addCase(mypageUploadFileTempPost.pending, (state) => {
        state.loading = true;
        state.error = "null";
        state.actionStatus = "pending";
      })
      .addCase(mypageUploadFileTempPost.fulfilled, (state, action) => {
        state.success = action.payload.success;
        state.loading = false;
        state.isLoading = false;
        state.message = action.payload.message;
        state.actionStatus = "fulfilled";
        state.actionName = "mypageUploadFileTempPost";
      })
      .addCase(mypageUploadFileTempPost.rejected, (state, action) => {
        state.loading = false;
        state.isLoading = false;
        state.errors = action.payload || {};
        state.actionStatus = "rejected";
      })
      // File uploading put
      .addCase(mypageUploadFilePut.pending, (state) => {
        state.loading = true;
        state.error = "null";
        state.actionStatus = "pending";
      })
      .addCase(mypageUploadFilePut.fulfilled, (state, action) => {
        state.success = action.payload.success;
        state.loading = false;
        state.isLoading = false;
        state.message = action.payload.message;
        state.actionStatus = "fulfilled";
        state.actionName = "fileUploadUpdating";
        state.isReloadPage = !state.isReloadPage;
      })
      .addCase(mypageUploadFilePut.rejected, (state, action) => {
        state.loading = false;
        state.isLoading = false;
        state.errors = action.payload || {};
        state.actionStatus = "rejected";
      })
      // File uploading delete
      .addCase(mypageUploadFileDelete.pending, (state) => {
        state.loading = true;
        state.error = "null";
        state.actionStatus = "pending";
      })
      .addCase(mypageUploadFileDelete.fulfilled, (state, action) => {
        state.success = action.payload.success;
        state.loading = false;
        state.isLoading = false;
        state.message = action.payload.message;
        state.actionStatus = "fulfilled";
        state.actionName = "fileUploadDeleting";
        state.isReloadPage = !state.isReloadPage;
      })
      .addCase(mypageUploadFileDelete.rejected, (state, action) => {
        state.loading = false;
        state.isLoading = false;
        state.errors = action.payload || {};
        state.actionStatus = "rejected";
      })
      // setChangePassword
      .addCase(setChangePassword.pending, (state) => {
        state.loading = true;
        state.error = "null";
        state.actionStatus = "pending";
      })
      .addCase(setChangePassword.fulfilled, (state, action) => {
        state.loading = true;
        state.isLoading = false;
        state.actionStatus = "fulfilled";
        state.success = action.payload.success;
        state.actionName = "setChangePassword";
        state.redirection = action.payload.redirection;
      })
      .addCase(setChangePassword.rejected, (state, action) => {
        state.loading = false;
        state.isLoading = false;
        state.errors = action.payload || {};
        state.actionStatus = "rejected";
      })
       // Update basic information
       .addCase(updateBasicInformation.pending, (state) => {
        state.loading = true;
        state.error = "null";
        state.actionName = "updateChange";
        state.actionStatus = "pending";
      })
      .addCase(updateBasicInformation.fulfilled, (state, action) => {
        state.loading = false;
        state.isLoading = false;
        state.message = action.payload.message;
        state.actionStatus = "fulfilled";
        state.actionName = "updateChange";
        state.successImage = action.payload.success;
        state.success = action.payload.success;
        state.changeEmailStatus = action.payload.data;
        state.isReloadPage = !state.isReloadPage;
      })
      .addCase(updateBasicInformation.rejected, (state, action) => {
        state.loading = false;
        state.isLoading = false;
        state.actionName = "updateChange";
        state.errors = action.payload || {};
        state.actionStatus = "rejected";
      })
      // get talent career information
      .addCase(getCareerInformation.pending, (state) => {
        state.loading = true;
        state.error = "null";
        state.actionStatus = "pending";
      })
      .addCase(getCareerInformation.fulfilled, (state, action) => {
        state.loading = true;
        state.isLoading = false;
        state.success = action.payload.success;
        state.message = action.payload.message;
        state.careerData = action.payload.careerData;
        state.actionStatus = "fulfilled";
        state.actionName = "getCareerInfo";
        state.successCareer = action.payload.success;
      })
      .addCase(getCareerInformation.rejected, (state, action) => {
        state.loading = false;
        state.isLoading = false;
        state.errors = action.payload || {};
        state.actionStatus = "rejected";
      })
      // Update talent career information
      .addCase(updateCareerInformation.pending, (state) => {
        state.loading = true;
        state.error = "null";
        state.actionName = "updateCareerInformation";
        state.actionStatus = "pending";
      })
      .addCase(updateCareerInformation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.message = action.payload.message;
        state.actionStatus = "fulfilled";
        state.actionName = "updateCareerInformation";
        state.successCareer = action.payload.success;
        state.success = action.payload.success;
        state.isReloadPage = !state.isReloadPage;
      })
      .addCase(updateCareerInformation.rejected, (state, action) => {
        state.loading = false;
        state.isLoading = false;
        state.errors = action.payload || {};
        state.actionName = "updateCareerInformation";
        state.actionStatus = "rejected";
      })
      
      // getBookmarkedList
      .addCase(getBookmarkedList.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionName = "getBookmarkedList";
        state.actionStatus = "pending";
      })
      .addCase(getBookmarkedList.fulfilled, (state, action) => {
        state.loading = false;
        state.bookmarkedItems = action.payload.results.data;
        state.countItems = action.payload.count;
      })
      .addCase(getBookmarkedList.rejected, (state, action) => {
        state.loading = false;
        state.actionStatus = "rejected";
        state.currentPage = parseInt(state.currentPage) > 1 ? parseInt(state.currentPage) - 1 : 1;
      })

      // getBookmarkedListMobile
      .addCase(getBookmarkedListMobile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.hasMore = false;
        state.actionName = "getBookmarkedListMobile";
        state.actionStatus = "pending";
      })
      .addCase(getBookmarkedListMobile.fulfilled, (state, action) => {
        state.loading = false;
        handleGetBookmarkedListMobileFulfilled(state, action);
      })
      .addCase(getBookmarkedListMobile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.actionStatus = "rejected";
        state.currentPageLoading = 1;
      })

      // setItemBookmark
      .addCase(setItemBookmark.pending, (state) => {
        state.loading = true;
        state.error = null;      
        state.actionStatus = "pending";
      })
      .addCase(setItemBookmark.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.actionName = "setItemBookmark";
        state.actionStatus = "fulfilled";
        state.bookmarkedItems = updateItemsById(state.bookmarkedItems, action.payload.data);
        state.bookmarkedItemsMobile = updateItemsById(state.bookmarkedItemsMobile, action.payload.data);
        state.isReloadBookmarkList = !state.isReloadBookmarkList;
      })
      .addCase(setItemBookmark.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.actionStatus = "rejected";
      })
  },
});

const mypageActions = {
  ...mypageSlice.actions,
}
export const {
  setActionName, setActionStatus, setCurrentPage, setCurrentPageLoading, setActiveTab, setChangeEmailStatus,
} = mypageSlice.actions
export { mypageActions }
export default mypageSlice.reducer

